// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4961e069","453":"162d55fa"}[chunkId] + ".chunk.js";
};